import React from "react"
import ActionFooter from "../../components/common/ActionFooter"

const ProductionStepExecutionFooter = ({ rightAction, leftAction = null, justifyBetween = false }) => {
  return (
    <ActionFooter
      rightAction={rightAction}
      leftAction={leftAction}
      justifyBetween={justifyBetween}
    />
  )
}


export default ProductionStepExecutionFooter